module.exports = __webpack_public_path__ + "img/icon-online.07090d55.svg";